import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Reveal from "@/components/Reveal";
import Label from "@/components/Label";
import { useLanguage } from "@/context/LanguageContext";
import { home } from "@/content/translations";

export default function HomePage() {
    const { lang } = useLanguage();
    const t = home[lang];

    return (
        <>
            <Header />
            <main data-testid="home-page" className="tm-page-in">
                <section className="max-w-[1360px] mx-auto px-8 sm:px-16 pt-24 sm:pt-32">
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 items-center">
                        <Reveal className="lg:col-span-7">
                            <Label>{t.label}</Label>
                            <h1 className="tm-serif text-[3.25rem] sm:text-[4.75rem] lg:text-[5.5rem] leading-[0.98] tracking-tight mt-8 text-[hsl(var(--tm-anthracite))]">
                                {t.h1a}<br />
                                <span className="italic text-[hsl(var(--tm-gold))]">{t.h1b}</span>
                            </h1>
                            <div className="mt-10 h-px w-28 bg-[hsl(var(--tm-gold))] tm-line-draw"></div>
                            <p className="mt-10 tm-serif text-[1.35rem] leading-relaxed text-[hsl(var(--tm-anthracite-soft))] max-w-xl">
                                {t.intro}
                            </p>
                            <div className="mt-12 flex items-center gap-5 flex-wrap">
                                <Link to="/expertise" className="tm-btn-primary" data-testid="cta-expertise">{t.ctaExpertise}</Link>
                                <Link to="/a-propos" className="tm-btn-ghost" data-testid="cta-apropos">{t.ctaAbout}</Link>
                            </div>
                        </Reveal>
                        <Reveal className="lg:col-span-5" delay={0.15}>
                            <div className="tm-card-lg overflow-hidden">
                                <img
                                    src="/images/hero-mouvement.jpg"
                                    alt={t.heroAlt}
                                    className="w-full h-[320px] sm:h-[420px] object-cover tm-kenburns"
                                    loading="eager"
                                />
                            </div>
                        </Reveal>
                    </div>
                </section>

                <section className="max-w-[1360px] mx-auto px-8 sm:px-16 mt-32 sm:mt-44">
                    <div className="tm-divider mb-16"></div>
                    <Reveal stagger className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-10 gap-y-14">
                        {t.pillars.map((p) => (
                            <div key={p.title}>
                                <h3 className="tm-serif text-xl text-[hsl(var(--tm-anthracite))]">{p.title}</h3>
                                <div className="mt-4 h-px w-10 bg-[hsl(var(--tm-gold))]"></div>
                                <p className="mt-5 text-[hsl(var(--tm-anthracite-soft))] leading-relaxed">{p.text}</p>
                            </div>
                        ))}
                    </Reveal>
                </section>

                <section className="max-w-[1360px] mx-auto px-8 sm:px-16 mt-32 sm:mt-44">
                    <Reveal className="flex items-end justify-between pb-8 mb-14">
                        <div>
                            <Label>{t.audiencesLabel}</Label>
                            <h2 className="tm-serif text-4xl sm:text-5xl mt-4 text-[hsl(var(--tm-anthracite))]">{t.audiencesTitle}</h2>
                        </div>
                    </Reveal>
                    <div className="tm-divider mb-10"></div>
                    <Reveal stagger className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        {t.audiences.map((a) => (
                            <div key={a.n} className="tm-card relative p-10 sm:p-14">
                                <span className="tm-label tm-mono text-[hsl(var(--tm-gold))]">{a.n}</span>
                                <h3 className="tm-serif text-3xl sm:text-4xl mt-8 leading-tight text-[hsl(var(--tm-anthracite))]">{a.title}</h3>
                                <p className="mt-6 text-[hsl(var(--tm-anthracite-soft))] max-w-md leading-relaxed">{a.text}</p>
                            </div>
                        ))}
                    </Reveal>
                    <div className="mt-14">
                        <Link to="/expertise" className="tm-label tm-gold-link">{t.methodologyLink}</Link>
                    </div>
                </section>

                <section className="max-w-[1360px] mx-auto px-8 sm:px-16 mt-32 sm:mt-44 mb-8">
                    <Reveal className="tm-surface p-10 sm:p-14">
                        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
                            <div className="lg:col-span-8">
                                <Label>{t.ctaBlockLabel}</Label>
                                <h2 className="tm-serif text-3xl sm:text-4xl mt-4 text-[hsl(var(--tm-anthracite))]">{t.ctaBlockTitle}</h2>
                                <p className="mt-5 text-[hsl(var(--tm-anthracite-soft))] leading-relaxed max-w-xl">{t.ctaBlockText}</p>
                            </div>
                            <div className="lg:col-span-4 flex lg:justify-end">
                                <a href="mailto:contact@timemetria.com?subject=Expertise%20request" className="tm-btn-primary">
                                    {t.ctaBlockButton}
                                </a>
                            </div>
                        </div>
                    </Reveal>
                </section>
            </main>
            <Footer />
        </>
    );
}
